import { roundRating } from '../../../../domain';
import ratingTextImg from './rating_text.png';
import ratingValueBackgroundImg from './rating_value_background.png';
import ratingValueTextSvg from './rating_value_text.svg';
import './DeliveryRating.css';

type DeliveryRatingProps = {
  rating?: number | null;
};

function formatDeliveryRatingLabel(rating: number): string {
  return `${roundRating(rating).toFixed(1).replace('.', ',')} из 5`;
}

/**
 * Order rating inside the delivery list card (result_frame).
 */
export function DeliveryRating({ rating }: DeliveryRatingProps) {
  const ratingLabel =
    rating != null && Number.isFinite(rating)
      ? formatDeliveryRatingLabel(rating)
      : null;

  return (
    <div className="delivery-rating" aria-hidden>
      <div className="delivery-rating__background" />
      <img
        className="delivery-rating__label"
        src={ratingTextImg}
        alt=""
        draggable={false}
      />
      <img
        className="delivery-rating__value-bg"
        src={ratingValueBackgroundImg}
        alt=""
        draggable={false}
      />
      {ratingLabel != null ? (
        <svg
          className="delivery-rating__value-text delivery-rating__value-text--live"
          width={164}
          height={73}
          viewBox="0 0 174 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden
        >
          <text
            className="delivery-rating__value-text-label"
            textAnchor="middle"
            xmlSpace="preserve"
            aria-live="polite"
          >
            <tspan x={87} y={48}>
              {ratingLabel}
            </tspan>
          </text>
        </svg>
      ) : (
        <img
          className="delivery-rating__value-text"
          src={ratingValueTextSvg}
          alt="3,8 из 5"
          draggable={false}
        />
      )}
    </div>
  );
}
